const supplies = [
  {
    id: 1,
    title: "Lista de Útiles - Pre Kinder",
    course: "Pre Kinder",
    fileUrl: "/utils/LISTA UTILES PREKINDER 2025.pdf",
  },
  {
    id: 2,
    title: "Lista de Útiles - Kinder",
    course: "Kinder",
    fileUrl: "/utils/LISTA UTILES KINDER 2025.pdf",
  },
  {
    id: 3,
    title: "Lista de Útiles - Medio Mayor",
    course: "1ro basico",
    fileUrl: "/utils/LISTA MEDIO MAYOR 2025.pdf",
  },
  {
    id: 4,
    title: "Informacion de la escuela",
    course: "informacion",
    fileUrl: "/utils/INFORMACION ESCUELA.pdf",
  },
  {
    id: 5,
    title: "Beca útiles escolares 2026",
    course: "Becas",
    fileUrl: "/utils/BECA UTILES ESCOLARES 2026.pdf",
  },
];

export default supplies;